<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <kt-row>
                <kt-col xs="12" md="6">
                    <payman-info :payman="form_data"></payman-info>
                </kt-col>
                <kt-col xs="12" md="6">
                    <gateway-statistics></gateway-statistics>
                    <payman-setting></payman-setting>
                </kt-col>
            </kt-row>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import { paymanSetting, paymanInfo } from './components'
import gatewayStatistics from './components/gateway-statistics'

export default {
    components: {
        mainContent,
        paymanSetting,
        paymanInfo,
        'gateway-statistics': gatewayStatistics
    },
    computed: {
        ...mapGetters('payman', [
            'form_data', 'status'
        ]),
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
                vm.$store.dispatch('payman/find', vm.hashid)
        })
    },
}
</script>

<style>
@media (min-width: 768px) {
    #payman-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>